import incentivePaymentVoucherPdf from '@/services/utils/incentivePaymentVoucherPdf';
import handleBarcode from "@/services/modules/barcode";
import handleCompany from "@/services/modules/company";
import { useStore } from "vuex";
import {  formatDate } from '@/services/utils/global.js';

const pdfPrinterHelper = () => {
    const { exportToPDF } = incentivePaymentVoucherPdf();
    const { fetchBarcode } = handleBarcode();
    const { fetchCompanyInfo } = handleCompany();
    const store = useStore();
    const userName = store.state.user.user.name;
    var barcode = '', qrcode = '';
    var company = {};

    const generatePdf = (companyId, paymentRes) => {
        let data = paymentRes.data;
        let incentivePayment = paymentRes.incentive_payment;
        let totalValue = paymentRes.total;

        let qrcodeData = JSON.stringify({
            ref_no: data.voucher_no,
            ref_date: data.date,
            created_by: userName,
            created_date_time: formatDate(new Date())
        })
        var barCodeQuery = `?code=${data.voucher_no}&qrcode=${qrcodeData}`;

        fetchBarcode(barCodeQuery).then( (res) => {
            barcode = res.barcode;
            qrcode = res.qrcode;
        }).then(() => {
            fetchCompanyInfo(companyId).then((res) => {
                company = res.data
            }).then(() => {
                exportToPDF(company, data, barcode, qrcode, incentivePayment, totalValue)
            })
        }).catch((e) => {
            console.log('Something went wrong');
        })
    }

    return{
        generatePdf
    }
}

export default pdfPrinterHelper;